import { put, takeLatest, all, select } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { generateTimeRangeKey } from 'helpers/timeBuckets';

import { resetActivitiesInitialState } from 'services/activities/duck';
import { resetCampaignInitialState } from 'services/campaign/duck';
import { resetChannelInitialState } from 'services/channel/duck';
import { resetLayerTwoInitialState } from 'services/layerTwo/duck';
import { resetSEMInitialState } from 'services/sem/duck';
import { resetTacticsInitialState } from 'services/tactics/duck';
import { resetTTDInitialState } from 'services/ttd/duck';
import { resetMetaChannelAvailability } from 'services/entities/duck';
import { resetSiteDirectInitialState } from 'services/siteDirect/duck';
import { resetSocialInitialState } from 'services/social/duck';
import { resetYoutubeInitialState } from 'services/youtube/duck';
import { resetRealValueInitialState } from 'services/realValue/duck';
import { resetHyperLocalInitialState } from 'services/hyperlocal/duck';

import { actions } from './duck';
import { getAPIConfig, getPreviousTimeRangeKey } from './selectors';

export function* resetDataInitialState() {
    yield put(resetMetaChannelAvailability());
    yield put(resetActivitiesInitialState());
    yield put(resetCampaignInitialState());
    yield put(resetChannelInitialState());
    yield put(resetLayerTwoInitialState());
    yield put(resetSEMInitialState());
    yield put(resetTacticsInitialState());
    yield put(resetTTDInitialState());
    yield put(resetSocialInitialState());
    yield put(resetSiteDirectInitialState());
    yield put(resetYoutubeInitialState());
    yield put(resetRealValueInitialState());
    yield put(resetHyperLocalInitialState());
}

export function* checkToReinitialize() {
    // If there is a previous API config, check the dates
    const previousKey = yield select(getPreviousTimeRangeKey);

    if (previousKey) {
        const apiConfig = yield select(getAPIConfig);

        // determine if there is a delta in previous dates requested and the next
        if (previousKey !== generateTimeRangeKey(apiConfig)) {
            yield* resetDataInitialState();
        } else {
            yield put(notify({
                id: 'no-date-change',
                status: 'success',
                message: 'Data is already up to date.'
            }));
        }
    } else {
        // If there isn't, assume we need to clear the data
        yield* resetDataInitialState();
    }
}


export default function* configSagas() {
    yield all([
        takeLatest(actions.CHANGE_TIME_RANGE, checkToReinitialize),
        takeLatest(actions.CHANGE_TIME_RANGE_BY_KEY, checkToReinitialize),
        // takeLatest(actions.CLEAR_OBJECTIVE_SHADOW, setObjectiveShadow)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/config/saga.js